export default __webpack_public_path__ + "static/media/newtabpage.22fea838.jpg";